<!-- The <ng-template> element is a good choice for dynamic components because it doesn't render any additional output. -->
<ng-template #contextTarget />
